import { useQuery } from 'react-query';
import { useRecoilValue } from 'recoil';
import { authState } from '@/recoil/auth';
import { getEmergencyMessageReason } from '@/utils/graphqlApis';

const useEmergencyMessageReason = () => {
  const { token } = useRecoilValue(authState);
  return useQuery(['order', 'emergency-message-reason'], () =>
    getEmergencyMessageReason(token)
  );
};

export default useEmergencyMessageReason;
